import { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';

import { NullComponents } from './nullComponents/NullComponents.tsx';
import { store } from './store.ts';

export const ToolkitReduxProvider = ({ children }: PropsWithChildren) => (
  <Provider store={store}>
    {children}
    <NullComponents />
  </Provider>
);
